/* ==========================================================================
   Cleanza theme.js - UI behaviors + Shopify AJAX cart
   ========================================================================== */
(function(){
'use strict';

var $ = function(s,c){return (c||document).querySelector(s);};
var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};

/* ---------- icons ---------- */
function icons(){ if(window.lucide) window.lucide.createIcons(); }
icons();

/* ---------- WORKS ON blobs ---------- */
var STAINS=[
  {n:'Food & drink',c:'#c94f3a',d:'Sauce, ketchup, juice'},
  {n:'Grass & dirt',c:'#5a8f3c',d:'Parks and playgrounds'},
  {n:'Spit-up',c:'#e0a93b',d:'Bibs and shoulders'},
  {n:'Coffee & tea',c:'#8a5a2b',d:'Morning spills'},
  {n:'Berries',c:'#7b3f8f',d:'Snack-time drips'},
  {n:'Chocolate',c:'#6b4327',d:'Little handprints'},
  {n:'Popsicle',c:'#d15b8f',d:'Summer melts'},
  {n:'Everyday spills',c:'#3a78b5',d:'The rest of them'}
];
function blobSvg(c){return '<svg class="blob" viewBox="0 0 100 100" aria-hidden="true"><path fill="'+c+'" d="M52 8c14-3 30 4 36 18 6 15-2 25-4 38-2 12 2 24-10 29-13 6-31 2-42-6C21 78 8 70 7 55 6 40 14 27 26 18 34 12 42 10 52 8z"/><circle cx="70" cy="30" r="6" fill="'+c+'" opacity=".55"/><circle cx="26" cy="72" r="4" fill="'+c+'" opacity=".5"/></svg>';}
var blobGrid=$('#blobGrid');
if(blobGrid){ blobGrid.innerHTML=STAINS.map(function(s){return '<div class="blob-card reveal">'+blobSvg(s.c)+'<h4>'+s.n+'</h4><small>'+s.d+'</small></div>';}).join(''); }

/* ---------- before/after ---------- */
function weave(base,stains){
  var lines='';var i;
  for(i=0;i<40;i++){lines+='<line x1="'+(i*20)+'" y1="0" x2="'+(i*20)+'" y2="500"/>';}
  for(i=0;i<26;i++){lines+='<line x1="0" y1="'+(i*20)+'" x2="800" y2="'+(i*20)+'"/>';}
  var dots='';for(i=0;i<40;i++){dots+='<line x1="'+(i*20+10)+'" y1="0" x2="'+(i*20+10)+'" y2="500"/>';}
  return '<svg viewBox="0 0 800 500" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"><rect width="800" height="500" fill="'+base+'"/><g opacity="0.5" stroke="#ffffff" stroke-width="1">'+lines+'</g><g opacity="0.35" stroke="#000000" stroke-width="1">'+dots+'</g>'+stains+'</svg>';
}
var stainBlobs='<path fill="#8a3a1f" opacity="0.9" d="M300 180c50-20 120-10 150 30 25 34 8 70-10 100-20 34-70 46-110 34-46-14-84-46-88-92-3-42 22-58 58-72z"/><path fill="#5a2412" opacity="0.85" d="M360 210c26-8 52 6 60 30 7 22-6 44-30 52-24 8-52-4-58-28-5-22 8-46 28-54z"/><circle cx="250" cy="150" r="20" fill="#7b3f8f" opacity="0.8"/><circle cx="520" cy="300" r="26" fill="#5a8f3c" opacity="0.75"/><circle cx="470" cy="140" r="14" fill="#c94f3a" opacity="0.8"/>';
if($('#baBefore')) $('#baBefore').innerHTML=weave('#eef2f6',stainBlobs);
if($('#baAfter')) $('#baAfter').innerHTML=weave('#f7fbff','');
(function(){
  var ba=$('#ba'); if(!ba) return;
  var dragging=false;
  function set(pct){pct=Math.max(2,Math.min(98,pct));ba.style.setProperty('--split',pct+'%');}
  function fromEvent(e){var r=ba.getBoundingClientRect();set((e.clientX-r.left)/r.width*100);}
  ba.addEventListener('pointerdown',function(e){dragging=true;ba.setPointerCapture(e.pointerId);fromEvent(e);});
  ba.addEventListener('pointermove',function(e){if(dragging)fromEvent(e);});
  ba.addEventListener('pointerup',function(){dragging=false;});
  ba.addEventListener('pointercancel',function(){dragging=false;});
  set(50);
})();

icons();

/* ---------- header shrink ---------- */
var hdr=$('#hdr');
if(hdr) window.addEventListener('scroll',function(){hdr.classList.toggle('shrunk', window.scrollY>20);},{passive:true});

/* ---------- mobile menu ---------- */
var mmenu=$('#mmenu');
if($('#hambBtn')) $('#hambBtn').onclick=function(){mmenu.classList.add('open');document.body.style.overflow='hidden';};
function closeMenu(){if(mmenu){mmenu.classList.remove('open');document.body.style.overflow='';}}
if($('#mclose')) $('#mclose').onclick=closeMenu;
$$('#mmenu [data-close]').forEach(function(a){a.addEventListener('click',closeMenu);});

/* ---------- toast ---------- */
var toastT;
function toast(m){var t=$('#toast');if(!t)return;$('#toastMsg').textContent=m;t.classList.add('show');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('show');},2600);}

/* ---------- FAQ ---------- */
$$('.q button').forEach(function(btn){
  btn.addEventListener('click',function(){
    var q=btn.parentElement, a=q.querySelector('.a'), open=q.classList.contains('open');
    $$('.q').forEach(function(x){x.classList.remove('open');x.querySelector('.a').style.maxHeight=null;});
    if(!open){q.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  });
});

/* ---------- reveals ---------- */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals=$$('.reveal');
  if(reduce || !('IntersectionObserver' in window)){reveals.forEach(function(el){el.classList.add('is-in');});return;}
  var io=new IntersectionObserver(function(es,ob){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');ob.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  reveals.forEach(function(el){io.observe(el);});
  setTimeout(function(){reveals.forEach(function(el){if(!el.classList.contains('is-in') && el.getBoundingClientRect().top < innerHeight*1.15) el.classList.add('is-in');});},1400);
})();

/* ---------- gallery thumbnails ---------- */
$$('#thumbs .thumb').forEach(function(t){t.addEventListener('click',function(){
  $$('#thumbs .thumb').forEach(function(x){x.classList.remove('active');});
  t.classList.add('active');
  var m=$('#galleryMain'); if(m && t.dataset.full) m.src=t.dataset.full;
});});

/* ---------- quantity + bundles + variant ---------- */
var selectedQty=1;
var qVal=$('#qVal');
function setQty(q){selectedQty=Math.max(1,q); if(qVal) qVal.textContent=selectedQty;
  $$('.bundle').forEach(function(b){b.classList.toggle('sel', parseInt(b.dataset.qty,10)===selectedQty);});
}
$$('.bundle').forEach(function(b){b.addEventListener('click',function(){setQty(parseInt(b.dataset.qty,10));});});
if($('#qPlus')) $('#qPlus').onclick=function(){setQty(selectedQty+1);};
if($('#qMinus')) $('#qMinus').onclick=function(){setQty(selectedQty-1);};

var addBtn=$('#addBtn');
var variantSelect=$('#variantSelect');
if(variantSelect){
  variantSelect.addEventListener('change',function(){
    var opt=variantSelect.options[variantSelect.selectedIndex];
    if(addBtn) addBtn.dataset.variantId=variantSelect.value;
    var pn=$('#priceNow'); if(pn && opt.dataset.price) pn.textContent=opt.dataset.price;
  });
}

/* data-buy: scroll to purchase module */
$$('[data-buy]').forEach(function(b){b.addEventListener('click',function(e){
  var target=$('#buy'); if(target){e.preventDefault(); target.scrollIntoView({behavior:'smooth'});}
});});

/* ==========================================================================
   Shopify AJAX cart
   ========================================================================== */
var overlay=$('#overlay'), cartDrawer=$('#cartDrawer');
var CART_CURRENCY='USD';
function money(c){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:CART_CURRENCY}).format(c/100);}catch(e){return '$'+(c/100).toFixed(2);}}
function openDrawer(){if(overlay)overlay.classList.add('show');if(cartDrawer)cartDrawer.classList.add('open');document.body.style.overflow='hidden';}
function closeDrawer(){if(overlay)overlay.classList.remove('show');if(cartDrawer)cartDrawer.classList.remove('open');document.body.style.overflow='';var a=$('#addedLbl');if(a)a.style.display='none';}
if(overlay) overlay.onclick=closeDrawer;
if($('#closeCart')) $('#closeCart').onclick=closeDrawer;
if($('#contShop')) $('#contShop').onclick=closeDrawer;
if($('#cartBtn')) $('#cartBtn').onclick=function(){renderCart();openDrawer();};
if($('#checkoutBtn')) $('#checkoutBtn').onclick=function(){window.location.href='/checkout';};

function setCount(n){var el=$('#cartCount');if(!el)return;el.textContent=n;el.classList.toggle('show',n>0);}

function renderCart(){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
    CART_CURRENCY=cart.currency||CART_CURRENCY;
    setCount(cart.item_count);
    var body=$('#cartBody'), foot=$('#cartFoot');
    if(!body) return cart;
    if(cart.item_count===0){
      body.innerHTML='<div class="cart-empty"><i data-lucide="shopping-bag"></i><p>Your cart is empty.</p></div>';
      if(foot) foot.style.display='none'; icons(); return cart;
    }
    if(foot) foot.style.display='block';
    body.innerHTML=cart.items.map(function(it,idx){
      var img=it.image?'<img src="'+it.image+'" alt="" style="width:100%;height:100%;object-fit:contain">':'';
      var vt=(it.variant_title && it.variant_title.indexOf('Default')===-1)?'<small>'+it.variant_title+'</small>':'';
      return '<div class="ci" data-line="'+(idx+1)+'">'+
        '<div class="cim">'+img+'</div>'+
        '<div class="cinfo"><b>'+it.product_title+'</b>'+vt+
          '<div class="crow"><span class="cstep">'+
            '<button data-dec aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button data-inc aria-label="Increase">+</button>'+
          '</span><span class="cprice">'+money(it.final_line_price)+'</span></div>'+
          '<button class="rm" data-rm style="margin-top:8px">Remove</button>'+
        '</div></div>';
    }).join('');
    var st=$('#subtotal'); if(st) st.textContent=money(cart.total_price);
    // free-delivery progress (threshold $50 = 2 bottles)
    var ship=$('#cartShip');
    if(ship){
      var THRESH=5000, sub=cart.total_price, rem=THRESH-sub;
      if(rem>0){ship.className='cart-ship';ship.innerHTML='Add <b>'+money(rem)+'</b> more for free delivery.<div class="track"><div class="fill" style="width:'+Math.min(100,sub/THRESH*100)+'%"></div></div>';}
      else{ship.className='cart-ship done';ship.innerHTML='<i data-lucide="check-circle-2"></i> Free delivery unlocked';}
    }
    body.querySelectorAll('.ci').forEach(function(row){
      var line=parseInt(row.dataset.line,10);
      var qty=cart.items[line-1].quantity;
      row.querySelector('[data-inc]').onclick=function(){changeLine(line,qty+1);};
      row.querySelector('[data-dec]').onclick=function(){changeLine(line,qty-1);};
      row.querySelector('[data-rm]').onclick=function(){changeLine(line,0);};
    });
    icons();
    return cart;
  }).catch(function(){});
}

function changeLine(line,quantity){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:quantity})})
    .then(function(r){return r.json();}).then(function(){renderCart();}).catch(function(){toast('Could not update cart');});
}

function addToCart(variantId,qty){
  if(!variantId){toast('Add a product in Shopify first');return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:qty}]})})
    .then(function(r){if(!r.ok) throw new Error('add');return r.json();})
    .then(function(){var a=$('#addedLbl');if(a)a.style.display='flex';return renderCart();})
    .then(function(){openDrawer();toast('Added to your cart');})
    .catch(function(){toast('Could not add to cart');});
}

if(addBtn) addBtn.addEventListener('click',function(){addToCart(parseInt(addBtn.dataset.variantId,10),selectedQty);});
/* offer: one-click add 2 bottles -> free delivery */
$$('[data-add-two]').forEach(function(b){b.addEventListener('click',function(){
  var vid = addBtn ? parseInt(addBtn.dataset.variantId,10) : parseInt(b.dataset.variantId,10);
  addToCart(vid,2);
});});
var stickyAdd=$('#stickyAdd');
if(stickyAdd && addBtn) stickyAdd.addEventListener('click',function(){addToCart(parseInt(addBtn.dataset.variantId,10),selectedQty);});

/* ---------- sticky mobile add-to-cart ---------- */
var stickyBuy=$('#stickyBuy');
if(stickyBuy && addBtn && 'IntersectionObserver' in window){
  new IntersectionObserver(function(ents){ents.forEach(function(en){
    stickyBuy.classList.toggle('show', !en.isIntersecting && innerWidth<=760 && en.boundingClientRect.top<0);
  });},{threshold:0}).observe(addBtn);
}

/* initial cart count sync */
renderCart();
})();
